// extracted by mini-css-extract-plugin
module.exports = {"tab":"ProfileView_tab__6aPma","tabItem":"ProfileView_tabItem__DCLRd"};